/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import type { ICellRendererParams } from 'ag-grid-community'
import { capitalizeWords } from '@sportninja/common/ts-utils'
import { paragraphSmall } from 'src/components/css'
import type { AttendancePlayer } from '../../types'
import { getSpareStatusColor } from '../../utils/attendanceRowState'

/** STATUS column (Eligible Game Spares): the availability request's status. */
const SpareStatusCell = ({ data }: ICellRendererParams<AttendancePlayer>) => {
  const requestStatus = data?.availability_request?.status

  return (
    <span css={textStyle} style={{ color: getSpareStatusColor(requestStatus) }}>
      {requestStatus ? capitalizeWords(requestStatus) : ''}
    </span>
  )
}

export default SpareStatusCell

const textStyle = css`
  ${paragraphSmall}
`
